import { Vista } from "@essenza/react";
import { useModel, useVista, useGraph, useApp } from "@essenza/react";
import { useEffect} from "react";
import { JobModel } from "../models/jobmodel";
import { JobList } from "../view/job_list";

export function JobCloseVistaController(c) {
    c.skin = JobCloseVista;
    let store = null;
    c.command = {

    }
}

export function JobCloseVista(info) {
    const [ctx, control] = useVista(JobCloseVistaController);
    const [model] = useModel();
    const activejob = useGraph(JobModel, "close");

    useEffect(() => {
        console.log("MODEL ", model);
        if (model) {
            model.read(JobModel, m => m.Close());
        }
    }, [model]);

    console.log("JOB-LIST-VISTA");
    return (
        <Vista context={ctx} >
            <div className="w100 py-md">
                <div className="centered max-width-sm text-center">
                  <h1>Offerte Chiuse</h1>
                            {/* <Button className="primaryButton bigButton" onClick={() => control.navigate("/offerta")}>
                                <NewApplicationIcon /> Crea una nuova offerta
                            </Button> */}
                    <JobList closed source={activejob?.get()} />
                </div>
            </div>
        </Vista>
    )
}